import { render, staticRenderFns } from "./awards-2023.vue?vue&type=template&id=116e37f9&scoped=true&"
import script from "./awards-2023.vue?vue&type=script&lang=js&"
export * from "./awards-2023.vue?vue&type=script&lang=js&"
import style0 from "./awards-2023.vue?vue&type=style&index=0&id=116e37f9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116e37f9",
  null
  
)

export default component.exports